<template>
  <b-form @submit="onSubmit">
    <b-card no-body class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b v-text="perfil.nome" />
          <div class="d-flex flex-row-reverse">
            <b-button type="submit" variant="exitos">Salvar</b-button>

            <router-link
              v-if="perfil?.cliente_id"
              :to="{ name: 'clientes_edit', params: { id: perfil.cliente_id } }"
              class="btn btn-outline-muted mr-2"
            >
              Voltar
            </router-link>
          </div>
        </div>
      </template>

      <b-tabs pills card vertical class="edit-menu-sidebar">
        <b-tab active>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.dados_basicos"
            />
            Dados Básicos
          </template>
          <DadosBasicos ref="dados_basicos" />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { cnpj as cnpjValidator } from "cpf-cnpj-validator";

import DadosBasicos from "./Form/DadosBasicos.vue";
import Endereco from "./Form/Endereco.vue";
import cloneDeep from "lodash/cloneDeep";
import { PluckItem } from "@/helpers/functions/ArrayHelpers";

export default {
  components: { DadosBasicos, Endereco },
  data: () => ({
    validations: {
      dados_basicos: true,
    },
  }),
  computed: {
    ...mapState("perfis", ["perfil"]),
  },
  methods: {
    ...mapActions("perfis", ["ActionSave", "ActionShow"]),
    async onSubmit(event) {
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
        return;
      }

      try {
        const payload = cloneDeep(this.perfil);

        payload.areas = PluckItem(payload.areas, "id");
        payload.categorias = PluckItem(payload.categorias, "id");
        payload.type =
          cnpjValidator.isValid(payload.documento) || !!payload.razao_social
            ? "pessoa_juridica"
            : "pessoa_fisica";

        await this.ActionSave(payload);
        this.$emit("saved", payload.id);

        this.$notifications.addNotification({
          message: "Registro salvo com sucesso",
          type: "success",
        });
      } catch (error) {
        const message = "Erro ao salvar";
        this.$notifications.addNotification({
          message,
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
    isValid() {
      this.validations.dados_basicos = this.$refs.dados_basicos.isValid();
      return Object.values(this.validations).every(Boolean);
    },
    async loadData() {
      try {
        this.$refs["dados_basicos"]?.validateProfileType?.();
      } catch (error) {
        this.$notifications.addNotification({
          message: error?.data?.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });
        this.$router.push({ name: "clientes_list" });
      }
    },
  },
  created() {
    this.loadData();
  },
};
</script>
